import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VehicleModelServices from "services/VehicleModelServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVehicleTypeSubmit = (id, data) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate, lang } =
    useContext(SidebarContext);
  const [, setResData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async (  data ) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
      const categoryData = {
        name: data.name,
        vehicle_category_id: Number(data.vehicle_type)
      };

      if (id) {
        const res = await VehicleModelServices.updateVehicleModel(id, categoryData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
        reset();
      } else {
        const res = await VehicleModelServices.addVehicleModel(categoryData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      setIsSubmitting(false);
      notifyError(err ? err?.response?.data?.message : err?.message);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!isDrawerOpen) {
      setResData({});
      setValue("name");
      setValue("vehicle_type")
      clearErrors("name");
      clearErrors();
      return;
    }
    if (id) {
      (async () => {
        try {
          const res = await VehicleModelServices.getVehicleModelById(id);

          if (res) {
            setResData(res.data);
            setValue("name", res.data.name);
            setValue("vehicle_type",res.data.vehicle_category_id);
          }
        } catch (err) {
          notifyError(err ? err.response.data.message : err.message);
        }
      })();
    }
  }, [id, setValue, isDrawerOpen, clearErrors, data, lang]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,setLoading,
    isSubmitting,
  };
};

export default useVehicleTypeSubmit;
